import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
  Box,
  useTheme,
} from '@mui/material';
import { tableLoadingStyles } from './TableLoading.styles';

const TableLoading = ({
  columns = [],
  rows = 5,
  showActions = true,
  height = 'auto',
}) => {
  const theme = useTheme();
  const totalFlex =
    columns.reduce((total, col) => total + (col.flex || 1), 0) +
    (showActions ? 1 : 0);

  const skeletonRows = Array.from({ length: rows }, (_, index) => index);

  return (
    <TableContainer
      component={Paper}
      sx={{
        ...tableLoadingStyles.tableContainer(theme),
        height: height !== 'auto' ? height : 'auto',
      }}
    >
      <Table>
        <TableHead sx={tableLoadingStyles.tableHead(theme)}>
          <TableRow>
            {columns.map((column, index) => (
              <TableCell
                key={index}
                align={column.align || 'left'}
                sx={{
                  ...tableLoadingStyles.tableCell(theme),
                  width: column.flex
                    ? `${(column.flex / totalFlex) * 100}%`
                    : column.width
                      ? column.width
                      : `${100 / columns.length}%`,
                  minWidth: 0,
                }}
              >
                <Skeleton
                  variant="text"
                  width="80%"
                  height={24}
                  sx={tableLoadingStyles.headerSkeleton}
                />
              </TableCell>
            ))}
            {showActions && (
              <TableCell
                align="center"
                sx={{
                  ...tableLoadingStyles.tableCell(theme),
                  width: `${(1 / totalFlex) * 100}%`,
                  minWidth: 0,
                }}
              >
                <Skeleton
                  variant="text"
                  width="60%"
                  height={24}
                  sx={tableLoadingStyles.headerSkeleton}
                />
              </TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {skeletonRows.map((_, rowIndex) => (
            <TableRow key={rowIndex} sx={tableLoadingStyles.tableRow(theme)}>
              {columns.map((column, colIndex) => (
                <TableCell
                  key={colIndex}
                  align={column.align || 'left'}
                  sx={{
                    ...tableLoadingStyles.tableCell(theme),
                    width: column.flex
                      ? `${(column.flex / totalFlex) * 100}%`
                      : column.width
                        ? column.width
                        : `${100 / columns.length}%`,
                    minWidth: 0,
                  }}
                >
                  <Skeleton
                    variant="text"
                    width={`${Math.random() * 40 + 60}%`}
                    height={20}
                    sx={tableLoadingStyles.cellSkeleton}
                  />
                </TableCell>
              ))}
              {showActions && (
                <TableCell
                  align="center"
                  sx={{
                    ...tableLoadingStyles.tableCell(theme),
                    width: `${(1 / totalFlex) * 100}%`,
                    minWidth: 0,
                  }}
                >
                  <Box sx={tableLoadingStyles.actionsContainer}>
                    <Skeleton
                      variant="circular"
                      width={32}
                      height={32}
                      sx={tableLoadingStyles.actionButtonSkeleton}
                    />
                    <Skeleton
                      variant="circular"
                      width={32}
                      height={32}
                      sx={tableLoadingStyles.actionButtonSkeleton}
                    />
                  </Box>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableLoading;
